import { useState, useCallback } from 'react';

export interface UsePostSelectionReturn {
  selectedPostIds: Set<string>;
  isSelected: (postId: string) => boolean;
  toggleSelection: (postId: string) => void;  // 点击切换单个帖子选中状态
  selectPosts: (postIds: string[]) => void;      // 框选使用：设置选中的帖子
  addToSelection: (postIds: string[]) => void;   // Shift框选：追加选择
  clearSelection: () => void;
  selectedCount: number;
}

export function usePostSelection(): UsePostSelectionReturn {
  const [selectedPostIds, setSelectedPostIds] = useState<Set<string>>(new Set());

  const isSelected = useCallback(
    (postId: string) => selectedPostIds.has(postId),
    [selectedPostIds]
  );

  const toggleSelection = useCallback((postId: string) => {
    setSelectedPostIds(prev => {
      const next = new Set(prev);
      if (next.has(postId)) {
        next.delete(postId);
      } else {
        next.add(postId);
      }
      return next;
    });
  }, []);

  const selectPosts = useCallback((postIds: string[]) => {
    setSelectedPostIds(new Set(postIds));
  }, []);

  const addToSelection = useCallback((postIds: string[]) => {
    setSelectedPostIds(prev => {
      const next = new Set(prev);
      postIds.forEach(id => next.add(id));
      return next;
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedPostIds(new Set());
  }, []);

  return {
    selectedPostIds,
    isSelected,
    toggleSelection,
    selectPosts,
    addToSelection,
    clearSelection,
    selectedCount: selectedPostIds.size,
  };
}
